'use strict';

var buyallutil = {
	updatepid: function (oldpid, newpid) {
		if (typeof $('#pids').val() !== typeof undefined) {
			var oldpid = oldpid.toString();
			var newpid = newpid.toString();
			if (oldpid !== newpid) {
				var newPids = '';
				var pids = $('#pids').val().split(',');
				for (var i = 0; i <= (pids.length - 1); i++) {
					var pid = pids[i].split(':')[0];
					if (pid === oldpid){
						var tempPid = pids[i].replace(oldpid, newpid);
						newPids = newPids+','+tempPid;
					} else {
						newPids = newPids+','+pids[i];
					}
				}
				if (newPids.indexOf(',') === 0)
					newPids = newPids.substr(1);
				$('#pids').val(newPids);
				buyallutil.updateqty(newpid, 1);
			}
		}
		return;
	},
	updateqty: function ($pid, $qty) {
		if (typeof $('#pids').val() !== typeof undefined) {
			$pid = $pid.toString();
			$qty = parseInt($qty).toString();
			if ($('#pids').val().indexOf($pid) > -1) {
				var newPids = '';
				var pids = $('#pids').val().split(',');
				for (var i = 0; i < pids.length; i++) {
					var $temp = pids[i];
					var pid = pids[i].split(':')[0];
					if ($pid === pid) {
						$temp =  pid + ':' + $qty;
					}
					newPids = newPids + ',' + $temp;
				}
				if (newPids.indexOf(',') === 0)
					newPids = newPids.substr(1);
				$('#pids').val(newPids);
				var $errEle = $("#all-a2c-error");
				$errEle.slideUp(500);
			}
		}
	}
};

export default buyallutil;